/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export const EVENT_JSCHUNKING_START = 'ChunkingEventStart';
export const EVENT_JSCHUNKING_STOP = 'ChunkingEventStop';
